<template>
  <Dialog
    :title="type ==='add' ? '新增角色' : '修改角色'"
    :visible="visible"
    @close="handleClose"
    width="600px"
  >
    <Form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="120px"
    >
      <FormItem
        label="角色名称"
        prop="name"
      >
        <Input v-model="form.name" />
      </FormItem>
      <FormItem
        label="角色编码"
        prop="code"
      >
        <Input
          v-model="form.code"
          :disabled="type !== 'add'"
        />
      </FormItem>
    </Form>
    <span slot="footer">
      <Button @click="cancel">取消</Button>
      <Button
        type="primary"
        @click="confirm"
      >
        确定
      </Button>
    </span>
  </Dialog>
</template>

<script>
import { Dialog, Form, FormItem, Input, Button } from 'element-ui';

export default {
  components: {
    Dialog,
    Form,
    FormItem,
    Input,
    Button,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    dataSource: {
      type: Object,
      default() {
        return {};
      },
    },

    type: {
      type: String,
      default: 'add',
    },
  },

  data() {
    return {
      form: {
        name: '',
        code: '',
      },
      rules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入角色编码', trigger: 'blur' }],
      },
    };
  },

  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.type === 'update') {
          this.form.name = this.dataSource.name;
          this.form.code = this.dataSource.code;
        }
      }
    },
  },

  methods: {
    cancel() {
      this.handleClose();
    },

    handleClose() {
      this.$emit('update:visible', false);
    },

    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.form);
          this.$refs.form.resetFields();
          this.handleClose();
        }
      });
    },
  },
};
</script>